import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Dialog, DialogTitle, IconButton, Typography, Card, useMediaQuery } from '@mui/material';
import styles from '../../devotee.module.scss';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
// import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import {
   LeftAndRightStyledIconsButton,
   StyledDateContainer,
   CommonButton,
   HcccCard,
} from '../../../common/StyledComponents/StyledFields';
import { useEffect, useState } from 'react';
import commonStyles from '../../../../App.module.scss';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../../../infrastructure/backendService';
import CommonDonations from '../../donation/commonDonations';
import EmptyPage from '../../../common/emptyPages/emptyPage';
import ToastComponent from '../../../common/toastComponent';
import apiPath from "../../../../config/apiPaths.json";
import { isEmpty, isNil } from 'lodash';
import { CustomTooltip } from '../../../common/muhurtham/muhurtham';

const CustomizedCalendarIcon = ({ style }: { style?: React.CSSProperties }) => {
   return (
      <div style={style}>
         <span role="img" aria-label="calendar">
            <CalendarTodayOutlinedIcon />
         </span>
      </div>
   );
};

export default function ActionAreaCard() {
   const [hovered, setHovered] = useState(null);
   const [currentIndex, setCurrentIndex] = useState(0);
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [isViewMoreClicked, setIsViewMoreClicked] = useState<boolean>(false);
   const [viewMoreData, setViewMoreData] = useState<string | null>(null);
   const [internalScroll, setInternalScroll] = useState(false);
   const [myFavorateList, setmyFavorateList] = useState<any[]>([]);
   const userName = sessionStorage.getItem("username");
   const isMobile = useMediaQuery('(max-width:600px)'); 

   const cardsPerPage = isMobile ? 1 : 4;

   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.favouritesEventsApi,
         params: {
            username: userName,
         },
         includeToken: true,
      })
         .then((res) => {
            console.log(res.data, "faveventssssssssssssss");
            setmyFavorateList(res.data);
         })
         .catch((err) => {
            console.log(err);
            // toast.error(`${err.message}`);
            setmyFavorateList(myFavorateList); // comment this line after getting response 200 from the server
         })
   }, [])

   const navigate = useNavigate();

   const handleMouseEnter = (poojaOrDonationName: any) => {
      console.log(
         'currentIndex',
         currentIndex,
         'CardId / HoveredCard',
         poojaOrDonationName,
         'currentIndex + 4 = ',
         currentIndex + 4,
      );
      setHovered(poojaOrDonationName);
   };

   const handleMouseLeave = () => {
      setHovered(null);
   };

   const handleDonate = (cardId: any) => {
      console.log('Donatee......');
      setIsOpen(true);
   };

   // const previousSlide = () => {
   //    setCurrentIndex((prevIndex) => (prevIndex - 4 < 0 ? 0 : prevIndex - 4));
   // };

   // const nextSlide = () => {
   //    setCurrentIndex((prevIndex) => {
   //       const nextIndex = prevIndex + 4;
   //       if (nextIndex >= myFavorateList.length) {
   //          return prevIndex;
   //       }
   //       return nextIndex;
   //    });
   // };

   const previousSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex - cardsPerPage < 0 ? 0 : prevIndex - cardsPerPage));
  };

  const nextSlide = () => {
      setCurrentIndex((prevIndex) => {
          const nextIndex = prevIndex + cardsPerPage;
          if (nextIndex >= myFavorateList.length) {
              return prevIndex;
          }
          return nextIndex;
      });
  };

   let visibleData = myFavorateList.slice(currentIndex, currentIndex + 4);

   const handleClose = (): void => {
      setIsOpen(false);
   };

   // const BasicDateRangePicker = (): React.ReactElement => {
   //    return (
   //       <StyledDateContainer>
   //          <LocalizationProvider dateAdapter={AdapterDayjs}>
   //             <DemoContainer components={['DateRangePicker']}>
   //                <CustomDateRangePicker
   //                   // slots={{ field: SingleInputDateRangeField }}
   //                   format="D/MM/YYYY"
   //                   sx={{ fontSize: '16px', lineHeight: '140%' }}
   //                   slotProps={{
   //                      textField: {
   //                         InputProps: {
   //                            startAdornment: (
   //                               <CustomizedCalendarIcon
   //                                  style={{
   //                                     color: '#22A699',
   //                                     height: '23px',
   //                                     width: '23px',
   //                                     marginRight: '10px',
   //                                  }}
   //                               />
   //                            ),
   //                         },
   //                      },
   //                   }}
   //                />
   //             </DemoContainer>
   //          </LocalizationProvider>
   //       </StyledDateContainer>
   //    );
   // };



   const handleViewMore = (url: string | undefined) => {
      window.open(url, '_blank');
   };

   const handleDonateButton = (): void => {
      navigate('/donations')
   };
   // const filteredData = myFavorateList.filter(event => event.poojaOrDonationName);
   const filteredData = myFavorateList.filter(event => event.poojaOrDonationName);


   const renderWithData = () => {
      return (
         <>
            <div className={styles.MyFavourateLayout}>
               <LeftAndRightStyledIconsButton
                  className={styles.carouselButton}
                  style={currentIndex === 0 ? { backgroundColor: '#FFF9E4' } : {}}
                  onClick={previousSlide}
                  disabled={currentIndex === 0}
               >
                  <ChevronLeftIcon />
               </LeftAndRightStyledIconsButton>
               <div className={styles.imageContainer}>
                  {filteredData.slice(currentIndex, currentIndex + cardsPerPage).map((card) => (
                     <HcccCard
                        key={card.poojaOrDonationName}
                        className={styles.Card_N_Image}
                     >
                        <Box className={styles.dataContainer}>
                           {card.imagePath && card.imagePath.trim() !== "" && card.imagePath !== "<>" ? (
                              <img className={styles.image} src={card.imagePath} alt={card.poojName} />
                           ) : (
                              <img className={styles.image} src="/images/LordShiva.svg" alt={card.poojName} />
                           )}
                           {/* <CustomTooltip title={card.poojaOrDonationName} placement='top'>
                           <Typography className={styles.cardText}>{card.poojaOrDonationName}</Typography>
                           </CustomTooltip> */}
                           <CustomTooltip title={card.poojaOrDonationName} placement="top-start" arrow>
                              <Typography className={styles.cardText}>
                                 {card.poojaOrDonationName.length > 30
                                    ? `${card.poojaOrDonationName.slice(0, 30)}...`
                                    : card.poojaOrDonationName}
                              </Typography>
                           </CustomTooltip>
                           <CustomTooltip title={card.dietyName} placement="top-start" arrow>
                              <Typography className={styles.cardText}>
                                 {card.dietyName && card.dietyName.length > 30
                                    ? `${card.dietyName.slice(0, 30)}...`
                                    : card.dietyName || ""}
                              </Typography>
                           </CustomTooltip>
                           <Box>
                              <CommonButton
                                 onClick={handleDonateButton}
                              >
                                 Donate
                              </CommonButton>
                           </Box>
                        </Box>
                          </HcccCard>
                      ))}
                  </div>
                  <LeftAndRightStyledIconsButton
                      className={styles.carouselButton}
                      style={currentIndex + cardsPerPage >= myFavorateList.length ? { backgroundColor: '#FFF9E4' } : {}}
                      onClick={nextSlide}
                      disabled={currentIndex + cardsPerPage >= myFavorateList.length}>
                      <ChevronRightIcon />
                  </LeftAndRightStyledIconsButton>
              </div>
              {/* Dialog component */}
          </>
      )
  };

   const renderEmptyData = () => {
      return (
         <>
            <EmptyPage
               imgUrl="/svg/myFavouriteEmpty.svg"
               typographyText="No Favourite Events"
            />
         </>
      );
   };

   return (
      <div>
         <ToastComponent />
         <h3 className={commonStyles.sectionTitle}>Favorite Events</h3>
         {myFavorateList.length === 0 ? renderEmptyData() : renderWithData()}
      </div>
   );
}
